export class NotPermissionError extends Error {
	constructor(messege: string) {
		super(messege);

		Object.setPrototypeOf(this, NotPermissionError.prototype);
	}
}